import { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import LoadingSpinner from '../components/LoadingSpinner';
import StatusBadge from '../components/StatusBadge';
import { apiGet, apiDownload } from '../api/client';

export default function Agenda() {
    const hoje = new Date().toISOString().split('T')[0];
    const [data, setData]         = useState(hoje);
    const [retiradas, setRetiradas] = useState([]);
    const [loading, setLoading]   = useState(true);

    useEffect(() => {
        setLoading(true);
        const params = new URLSearchParams({ data, por_pagina: 100 });
        apiGet(`/api/admin/retiradas?${params}`).then(res => {
            if (res?.success) setRetiradas(res.data.dados);
            setLoading(false);
        });
    }, [data]);

    const sucatas    = retiradas.filter(r => r.tipo_lote === 'sucata');
    const conservados = retiradas.filter(r => r.tipo_lote === 'conservado');

    const exportar = (fmt) =>
        apiDownload(
            `/api/admin/exportar?tipo=agenda&data=${data}&formato=${fmt}`,
            `agenda_${data}.${fmt}`
        );

    return (
        <Layout>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                <h1 style={{ margin: 0, fontSize: '24px', color: '#1B2631' }}>Agenda do dia</h1>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <input
                        type="date"
                        value={data}
                        onChange={e => setData(e.target.value)}
                        style={{ padding: '8px 12px', border: '1px solid #D5D8DC', borderRadius: '6px', fontSize: '14px' }}
                    />
                    <button onClick={() => exportar('xlsx')} style={btnExport(false)}>Exportar para Excel</button>
                </div>
            </div>

            {loading ? <LoadingSpinner /> : (
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                    <ColunaAgenda titulo="Sucata" cor="#B7770D" bg="#FEF9E7" retiradas={sucatas} />
                    <ColunaAgenda titulo="Conservado" cor="#1A5276" bg="#EAF4FB" retiradas={conservados} />
                </div>
            )}
        </Layout>
    );
}

function ColunaAgenda({ titulo, cor, bg, retiradas }) {
    return (
        <div style={{ background: '#fff', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
            <div style={{ background: bg, padding: '14px 20px', borderBottom: `3px solid ${cor}` }}>
                <span style={{ fontWeight: '700', color: cor, fontSize: '15px' }}>{titulo}</span>
                <span style={{ color: cor, fontSize: '13px', marginLeft: '8px', opacity: 0.8 }}>
                    {retiradas.length} agendamento(s)
                </span>
            </div>

            {retiradas.length === 0 ? (
                <p style={{ padding: '24px', color: '#95A5A6', textAlign: 'center' }}>
                    Nenhum agendamento.
                </p>
            ) : (
                <div style={{ padding: '8px' }}>
                    {retiradas.map(r => (
                        <div key={r.id} style={{
                            padding:      '12px 14px',
                            borderRadius: '8px',
                            marginBottom: '6px',
                            background:   '#F8F9FA',
                            borderLeft:   `4px solid ${cor}`,
                        }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <span style={{ fontWeight: '600', color: '#1B2631', fontSize: '14px' }}>
                                    {r.hora_inicio}
                                </span>
                                <StatusBadge status={r.status} />
                            </div>
                            <div style={{ fontSize: '13px', color: '#2C3E50', marginTop: '4px' }}>
                                {r.cliente_nome}
				{r.orgao_recolhedor && (
    <div style={{
        fontSize: '11px',
        color: '#7F8C8D',
        marginTop: '2px'
    }}>
        Comitente: {r.orgao_recolhedor}
    </div>
)}
                            </div>
                            <div style={{ fontSize: '12px', color: '#7F8C8D', marginTop: '2px' }}>
                                {r.quantidade_lotes} lote(s) · {r.lotes.join(', ')}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

const btnExport = (sec) => ({
    padding: '8px 14px', fontSize: '13px', fontWeight: '600',
    borderRadius: '6px', cursor: 'pointer',
    background: sec ? '#fff' : '#1B4F72',
    color:      sec ? '#1B4F72' : '#fff',
    border:     sec ? '1px solid #1B4F72' : 'none',
});
